import { reportInventoriesTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_REPORT_INVENTORIES, SET_REPORT_INVENTORIES_FILTERS, RESTORE_INITIAL } = reportInventoriesTypes;

const initialState = {
  ReportInventories: [],
  startDate: newDate(),
  endDate: newDate(),
  date: newDate(),
  station: null,
};

export const reportInventoriesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_INVENTORIES:
      return { ...state, ReportInventories: payload };
    case SET_REPORT_INVENTORIES_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
};
